<template>
    <v-progress-linear
        :value="percentage"
        style="border-radius: 4px"
        background-color="white"
        :indeterminate="!percentage"
        color="tretiary"
        height="25"
    />
</template>

<script>
import Dialog from "@/components/Dialog.vue";
import RichDataTable from "@/components/RichDataTable/RichDataTable";
import ImportResultRowClientStatus from "@/views/Import/Result/ImportResultRowClientStatus";
import {computed} from "@vue/composition-api";

export default {
    name: "PrimaryLoadingBar",
    components: {
        RichDataTable,
        Dialog,
        ImportResultRowClientStatus
    },
    props: {
        value: {
            type: Number,
            required: true
        },
        total: {
            type: Number,
            default: null
        }
    },
    setup(props) {
        const percentage = computed(() => {
            if (props.total === null || props.value === null) {
                return false
            }

            return (100 * props.value) / props.total;
        })

        return {
            percentage
        }
    }
};
</script>
